import { useEffect, useState } from "react";

interface Viewport {
	width: number;
	height: number;
}

const useViewport = () => {
	const [windowSize, setWindowSize] = useState<Viewport>({
		width: typeof window !== "undefined" ? window.innerWidth : 0,
		height: typeof window !== "undefined" ? window.innerHeight : 0,
	});

	useEffect(() => {
		function handleResize() {
			setWindowSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		}
		window.addEventListener("resize", handleResize);
		handleResize();
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return windowSize;
};

export default useViewport;
